import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/app/admin" : "/app");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="container-app py-16 grid lg:grid-cols-2 gap-16 items-center">
      <div className="hidden lg:block">
        <div className="label-eyebrow">Acceso</div>
        <h1 className="serif text-5xl mt-3 leading-tight">Bienvenido de vuelta.</h1>
        <p className="mt-6 text-muted-foreground max-w-md">Tu reputación, tus delegaciones, tus mediadores favoritos — todo en un solo lugar.</p>
      </div>
      <form onSubmit={submit} className="panel p-10 max-w-md w-full mx-auto" data-testid="login-form">
        <h2 className="serif text-3xl">Ingresar</h2>
        <p className="text-sm text-muted-foreground mt-1">Usa tu correo y contraseña.</p>
        <div className="mt-8 space-y-4">
          <div>
            <label className="label-eyebrow">Correo</label>
            <input className="field mt-1.5" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="login-email"/>
          </div>
          <div>
            <label className="label-eyebrow">Contraseña</label>
            <div className="relative mt-1.5">
              <input
                className="field pr-10 w-full"
                type={showPwd ? "text" : "password"}
                required
                value={password}
                onChange={(e)=>setPassword(e.target.value)}
                data-testid="login-password"
                autoComplete="current-password"
              />
              <button
                type="button"
                onClick={()=>setShowPwd(!showPwd)}
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-muted-foreground hover:text-foreground"
                data-testid="login-password-toggle"
                tabIndex={-1}
                aria-label={showPwd ? "Ocultar contraseña" : "Mostrar contraseña"}
              >
                {showPwd ? <EyeOff size={15}/> : <Eye size={15}/>}
              </button>
            </div>
          </div>
          <div className="text-right -mt-2">
            <Link to="/olvide-mi-contrasena" className="text-xs text-muted-foreground hover:text-foreground link-underline" data-testid="forgot-link">¿Olvidaste tu contraseña?</Link>
          </div>
          {error && <div className="text-sm text-[hsl(var(--destructive))]" data-testid="login-error">{error}</div>}
          <button type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-60" data-testid="login-submit">{loading ? "Ingresando…" : "Ingresar"}</button>
          <div className="text-sm text-muted-foreground text-center">
            ¿Aún no tienes cuenta? <Link to="/register" className="link-underline text-foreground">Regístrate</Link>
          </div>
        </div>
      </form>
    </div>
  );
}
